// extracted by mini-css-extract-plugin
module.exports = {"toast":"_9827","text":"d1d9"};